<template>
  <div :class="$style.wrap">
    <!-- tab选项卡 -->
    <ul :class="$style.tab">
      <li
        v-for="(item, index) in ladingList"
        :key="index"
        :class="[$style.tab_item, statusIndex == index && $style.active]"
        @click="setLadingStatus(item, index)"
      >
        {{ item.name }}
      </li>
    </ul>
    <template v-if="overLoading">
      <!--有数据-->
      <div :class="$style.list" v-if="questionList.length > 0">
        <div
          :class="$style.info_detail"
          v-for="(item, index) in questionList"
          :key="index"
          @click="openDetail(item)"
        >
          <p>{{ item.title }}</p>
          <p>{{ item.input_time }}</p>
          <p :class="[item.status == 1 ? $style.deal : $style.default]">
            {{ statusText[item.status].name }}
            <van-icon :name="statusText[item.status].icon" />
            <span :class="$style.tip" v-if="item.has_readed == 0">1</span>
          </p>
        </div>
      </div>
      <!-- 无提单 -->
      <the-empty v-else name="order" top="4" />
    </template>
    <!-- 客服对话框 -->
    <CustomerService
      ref="service"
      :show="show"
      @handlerShow="handlerShow"
      @changeStatus="changeStatus"
    />
  </div>
</template>

<script>
import { getWorksheetList, worksheetDetail } from "@/http/serve";
import { mapActions, mapGetters } from "vuex";
import CustomerService from "./components/CustomerService";
import TheEmpty from "@/components/TheEmpty";
export default {
  name: "mayLading",
  components: {
    CustomerService,
    TheEmpty
  },
  data() {
    return {
      overLoading: false,
      show: false,
      statusType: this.$ls.get("statusType", 5), //订单类型
      statusIndex: this.$ls.get("statusIndex", ""), //订单状态
      statusText: {
        0: { icon: "clock", name: "处理中" },
        2: { icon: "clock", name: "处理中" },
        1: { icon: "more", name: "已回复" },
        3: { icon: "checked", name: "已解决" },
        4: { icon: "clear", name: "不受理" }
      },
      ladingList: [
        { name: "全部", id: 5 },
        { name: "已回复", id: 1 },
        { name: "处理中", id: 0 },
        { name: "已解决", id: 3 }
      ],
      questionList: []
    };
  },
  mounted() {
    this.getLading();
  },
  computed: {
    ...mapGetters(["gameId"])
  },
  methods: {
    ...mapActions(["SetGame"]),
    /**
     * @description 改变订单状态
     * @param {id} id  - 问题id
     */
    changeStatus(id) {
      let index = this.questionList
        .map(item => {
          return item.id;
        })
        .indexOf(id);
      this.$set(this.questionList[index], "status", 0);
    },
    /**
     * @description 展示客服对话详情
     * @param {object} item  - 问题信息
     */
    openDetail(item) {
      if (item && item.has_readed) {
        item.has_readed == 0 && this.$set(item, "has_readed", 1);
      }
      this.handlerShow(item);
    },
    /**
     * @description 客服对话弹框
     * @param {object} item  - 问题信息
     */
    handlerShow(item) {
      this.show ? (this.show = false) : this.getServiceList(item);
    },
    /**
     * @description 获取客服对话列表
     * @param {object} item  - 问题信息
     */
    async getServiceList(item) {
      let parmas = {
        q_id: item.id
      };
      let res = await worksheetDetail(parmas);
      if (res.rcode != 0) return;
      this.$refs.service.getListInfo(res.data, item);
      this.show = true;
    },
    /**
     * @description 获取提单列表
     */
    async getLading() {
      this.overLoading = false;
      let parmas = {
        game_id: this.gameId,
        status: this.statusType
      };
      let res = await getWorksheetList(parmas);
      let { rcode, data } = res;
      if (rcode != 0) return;
      this.questionList = data;
      this.overLoading = true;
    },
    /**
     * @description 设置滚动条高度
     */
    setScorllTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    /**
     * @description 选择提单状态
     * @param {object} item  - 提单信息
     * @param {number} index - 索引
     */
    setLadingStatus(item, index) {
      this.setScorllTop();
      this.statusIndex = index;
      this.$ls.set("statusIndex", this.statusIndex);
      this.statusType = item.id;
      this.$ls.set("statusType", this.statusType);
      this.getLading();
    },
    /**
     * @description 移除存储数据
     */
    removeAll() {
      this.$ls.remove("statusIndex");
      this.$ls.remove("statusType");
    }
  },
  beforeRouteLeave(to, from, next) {
    this.removeAll();
    next();
  }
};
</script>
<style lang="less" module>
.wrap {
  .wrap-center;
}
.tab {
  .size(100%, 0.81rem);
  .flex-row;
  .flex-around;
  max-width: 750px;
  position: fixed;
  top: 1.1rem;
  z-index: 99;
  background-color: #ffffff;
  &_item {
    .size(25%, auto);
    .flex-center;
    line-height: 0.8rem;
    font-size: 0.28rem;
    color: #818181;
    border-right: 0.01rem solid #e4e4e4;
    cursor: pointer;
  }
}
.active {
  color: #48d5af;
  border-bottom: 0.01rem solid #48d5af;
  cursor: default;
}

.list {
  width: 7rem;
  margin: 2rem 0 1.5rem 0;
  .info_detail {
    cursor: pointer;
    .flex-start;
    p {
      .flex-center;
    }
    p:nth-of-type(1) {
      .size(2.4rem, 100%);
      font-size: 0.28rem;
    }
    p:nth-of-type(2) {
      .size(2.8rem, 100%);
      font-size: 0.24rem;
      color: #a0a0a0;
    }
    p:nth-of-type(3) {
      .size(2rem, 100%);
      .flex-row;
      font-size: 0.24rem;
    }
  }
}
.deal {
  color: #e93201;
  :global {
    .van-icon {
      margin-left: 0.12rem;
      color: #f09a8d;
    }
  }
}
.default {
  color: #818181;
  :global {
    .van-icon {
      margin-left: 0.12rem;
      color: #cecece;
    }
  }
}
.info_detail {
  .size(100%, auto);
  border-bottom: 0.01rem solid #e4e4e4;
  & > p {
    .flex-center;
    .flex-col;
    min-height: 1rem;
    position: relative;
  }
}
.info_detail:hover {
  background: Honeydew;
}

.customer_wrap {
  .size(100%);
  background: #fff;
  position: relative;
}
.tip {
  position: absolute;
  top: 27%;
  right: 10%;
  color: #fff;
  font-size: 0.12rem;
  text-align: center;
  background-color: #ee0a24;
  border: 1px solid #fff;
  border-radius: 50%;
  transform: translate(50%, -50%);
  transform-origin: 100%;
  width: 1.5em;
  height: 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
